<script setup lang="ts">
// Step 1: brand-y "hello" — concentric pulse rings around a stylised
// voice-AI mark (sparkle + headset arc). Pure SVG so it scales crisply
// and stays themable via currentColor.
</script>

<template>
  <div class="relative h-full w-full flex items-center justify-center">
    <svg
      viewBox="0 0 320 220"
      class="h-full w-auto"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="wg-intro-core" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="rgb(var(--accent))" />
          <stop offset="100%" stop-color="#d946ef" />
        </linearGradient>
        <radialGradient id="wg-intro-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="rgb(var(--accent))" stop-opacity="0.55" />
          <stop offset="100%" stop-color="rgb(var(--accent))" stop-opacity="0" />
        </radialGradient>
      </defs>

      <!-- soft glow behind the core -->
      <circle cx="160" cy="110" r="70" fill="url(#wg-intro-glow)" />

      <!-- pulsing rings -->
      <g fill="none" stroke="url(#wg-intro-core)" stroke-width="1.5" opacity="0.9">
        <circle cx="160" cy="110" r="32">
          <animate attributeName="r" values="32;58;32" dur="3.6s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.6;0;0.6" dur="3.6s" repeatCount="indefinite" />
        </circle>
        <circle cx="160" cy="110" r="44">
          <animate attributeName="r" values="44;72;44" dur="3.6s" begin="0.6s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.45;0;0.45" dur="3.6s" begin="0.6s" repeatCount="indefinite" />
        </circle>
        <circle cx="160" cy="110" r="56">
          <animate attributeName="r" values="56;86;56" dur="3.6s" begin="1.2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.3;0;0.3" dur="3.6s" begin="1.2s" repeatCount="indefinite" />
        </circle>
      </g>

      <!-- core disk -->
      <circle cx="160" cy="110" r="28" fill="url(#wg-intro-core)" />
      <!-- sparkle glyph -->
      <g transform="translate(160 110)" fill="white">
        <path d="M0 -12 L2.4 -2.4 L12 0 L2.4 2.4 L0 12 L-2.4 2.4 L-12 0 L-2.4 -2.4 Z" />
        <circle cx="9" cy="-9" r="2" />
        <circle cx="-9" cy="8" r="1.5" />
      </g>

      <!-- floating mini-bubbles -->
      <g fill="white" opacity="0.85">
        <circle cx="70" cy="70" r="4">
          <animate attributeName="cy" values="70;62;70" dur="4s" repeatCount="indefinite" />
        </circle>
        <circle cx="252" cy="80" r="3">
          <animate attributeName="cy" values="80;88;80" dur="4.4s" repeatCount="indefinite" />
        </circle>
        <circle cx="240" cy="160" r="5">
          <animate attributeName="cy" values="160;152;160" dur="3.8s" repeatCount="indefinite" />
        </circle>
        <circle cx="80" cy="160" r="3">
          <animate attributeName="cy" values="160;168;160" dur="4.2s" repeatCount="indefinite" />
        </circle>
      </g>
    </svg>
  </div>
</template>
